import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Ui::TextInput\n  @value={{this.formattedTime}}\n  @onChange={{this.updateTime}}\n  @error={{@error}}\n  ...attributes\n  {{on \'focus\' this.selectInputText}}\n/>")